import { EducationalService } from '../models/educational-service.model';

export const EDUCATIONAL_SERVICES: EducationalService[] = [
  {
    icon: '🎥',
    title: 'Live Classes',
    description: 'Interactive real-time lessons with expert teachers and peer collaboration.',
    features: ['HD Video', 'Interactive Board', 'Q&A Sessions']
  },
  {
    icon: '📚',
    title: 'Smart Library',
    description: 'AI-powered recorded sessions with intelligent search and bookmarking.',
    features: ['AI Search', 'Smart Bookmarks', 'Variable Speed']
  },
  {
    icon: '🎯',
    title: 'Assessment Tools',
    description: 'Comprehensive testing and evaluation with instant feedback.',
    features: ['Auto Grading', 'Progress Tracking', 'Detailed Analytics']
  },
  {
    icon: '👨‍🏫',
    title: 'Expert Tutoring',
    description: 'One-on-one personalized guidance from qualified educators.',
    features: ['Personal Mentor', 'Custom Schedule', 'Individual Focus']
  },
  {
    icon: '🏆',
    title: 'Achievement System',
    description: 'Gamified learning with rewards, badges, and progress milestones.',
    features: ['Learning Badges', 'Progress Rewards', 'Leaderboards']
  },
  {
    icon: '🌐',
    title: 'Virtual Classroom',
    description: 'Immersive 3D learning environments for enhanced engagement.',
    features: ['3D Environment', 'Virtual Labs', 'Interactive Simulations']
  }
];
